// BRWN CLUB — Cart Drawer JS
(function () {
  'use strict';

  var drawer = null;
  var overlay = null;
  var cartPageNeedsRefresh = false;

  function getDrawer() {
    drawer = document.getElementById('bc-cart-drawer');
    overlay = document.getElementById('bc-overlay');
    return drawer;
  }

  function lockScroll() {
    if (window.BRWNScroll) window.BRWNScroll.lock('bc-cart-open');
    else {
      document.body.classList.add('bc-cart-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function unlockScroll() {
    if (window.BRWNScroll) window.BRWNScroll.unlock('bc-cart-open');
    else {
      document.body.classList.remove('bc-cart-open');
      document.body.style.overflow = '';
    }
  }

  function openCartDrawer() {
    if (!getDrawer()) return false;

    drawer.classList.add('is-open', 'bc-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');

    if (overlay) {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
    }

    lockScroll();
    updateCart();
    return true;
  }

  function closeCartDrawer() {
    if (!getDrawer()) return;

    drawer.classList.remove('is-open', 'bc-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');

    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
    }

    unlockScroll();
    if (cartPageNeedsRefresh && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  function updateCartCount(count) {
    var countNumber = Number(count) || 0;
    var badges = document.querySelectorAll('#bc-cart-count, .bc-header__cart-count, [data-brwnlux-cart-count]');

    badges.forEach(function (badge) {
      badge.textContent = countNumber > 0 ? countNumber : '';
      badge.classList.toggle('is-empty', !(countNumber > 0));
      badge.classList.add('is-updated');
      window.setTimeout(function () { badge.classList.remove('is-updated'); }, 180);
    });
  }

  function bindDrawerEvents() {
    if (!getDrawer()) return;

    var closeBtn = drawer.querySelector('.bc-cart-drawer__close');
    if (closeBtn && !closeBtn.dataset.bcCartBound) {
      closeBtn.dataset.bcCartBound = 'true';
      closeBtn.addEventListener('click', closeCartDrawer);
    }

    drawer.querySelectorAll('[data-bc-qty-btn]').forEach(function (btn) {
      if (btn.dataset.bcCartBound) return;
      btn.dataset.bcCartBound = 'true';
      btn.addEventListener('click', function () {
        var qty = parseInt(this.dataset.qty, 10);
        updateLineItem(this.dataset.key, isNaN(qty) ? 0 : qty);
      });
    });

    drawer.querySelectorAll('[data-bc-remove]').forEach(function (btn) {
      if (btn.dataset.bcCartBound) return;
      btn.dataset.bcCartBound = 'true';
      btn.addEventListener('click', function () {
        updateLineItem(this.dataset.key, 0);
      });
    });
  }

  function refreshDrawer() {
    if (!getDrawer()) return Promise.resolve();

    return fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections['cart-drawer'];
        if (!html) return;

        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#bc-cart-drawer');
        if (!fresh) return;

        var wasOpen = drawer.classList.contains('is-open') || drawer.classList.contains('bc-cart-drawer--open');
        drawer.innerHTML = fresh.innerHTML;
        if (wasOpen) {
          drawer.classList.add('is-open', 'bc-cart-drawer--open');
          drawer.setAttribute('aria-hidden', 'false');
        }
        bindDrawerEvents();
      })
      .catch(function (err) { console.warn('Cart drawer refresh failed', err); });
  }

  function updateCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawer().then(function () { return cart; });
      })
      .catch(function (err) { console.warn('Cart update failed', err); });
  }

  window.updateCart = updateCart;

  var lineUpdatePending = false;
  function showCartError(message) {
    if (!getDrawer()) return;
    var el = drawer.querySelector('[data-cart-error]');
    if (!el) { el = document.createElement('p'); el.setAttribute('data-cart-error', ''); el.setAttribute('role', 'alert'); el.style.cssText = 'padding:12px 24px;color:#8b3426;font-size:13px'; drawer.appendChild(el); }
    el.textContent = message;
  }
  function updateLineItem(key, qty) {
    if (lineUpdatePending) return Promise.resolve();
    lineUpdatePending = true;
    showCartError('');
    drawer.querySelectorAll('[data-bc-qty-btn], [data-bc-remove]').forEach(function (btn) { btn.disabled = true; });
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'We could not update your bag. Please try again.'); return data; }); })
      .then(function () { cartPageNeedsRefresh = true; return updateCart(); })
      .then(function () { openCartDrawer(); })
      .catch(function (err) { showCartError(err.message || 'We could not update your bag. Please try again.'); })
      .finally(function () { lineUpdatePending = false; if (getDrawer()) drawer.querySelectorAll('[data-bc-qty-btn], [data-bc-remove]').forEach(function (btn) { btn.disabled = false; }); });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bc-open-cart]');
    if (!trigger) return;

    if (getDrawer()) {
      event.preventDefault();
      event.stopPropagation();
      openCartDrawer();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.id === 'bc-overlay') closeCartDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDrawer();
  });

  document.addEventListener('bc:cart:updated', function () {
    updateCart().then(openCartDrawer);
  });

  document.addEventListener('cart:change', function (event) {
    if (event.detail && typeof event.detail.item_count !== 'undefined') {
      updateCartCount(event.detail.item_count);
    }
    refreshDrawer().then(openCartDrawer);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      getDrawer();
      bindDrawerEvents();
    });
  } else {
    getDrawer();
    bindDrawerEvents();
  }
})();
